<template>
  <div class="opening bodyFont">
    <header-bar
      :reverse="true"
      :show-back="false"
    />
    <header class="header">
      <h3 class="heading">
        NYBG
      </h3>
      <h4 class="sub-heading">
        Interactive Mobile Guide
      </h4>
      <router-link
        class="button"
        :to="{name: 'choose'}"
      >
        Start Experience
      </router-link>
    </header>

    <div class="backdrop">
      <img src="../assets/home/home-bg-image.jpg"><!-- Change text on this image -->
    </div>

    <footer-logos />
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
    }
  },
  mounted() {
    window.__sharethis__.load('custom-share-buttons')
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.backdrop {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header{
  padding-bottom: 30px;
}
.heading{
  margin-bottom: 0;
  font-size:5rem;
  line-height: 1.1;
  text-align: center;
}
.sub-heading{
  margin-bottom:1rem;
  font-size:inherit;
  font-family: $font-sans;
}

</style>
